<template>
    <el-dropdown @command="handleCommand" split-button type="primary">
        <span class="el-dropdown-link">
            variables
        </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
                command="{{companyName}}"
                v-pre>companyName</el-dropdown-item>
            <el-dropdown-item
                command="{{domainName}}"
                v-pre>domainName</el-dropdown-item>
            <el-dropdown-item
                command="{{companyAddress1}}"
                v-pre>companyAddress1</el-dropdown-item>
            <el-dropdown-item
                command="{{companyAddress2}}"
                v-pre>companyAddress2</el-dropdown-item>
            <el-dropdown-item
                command="{{companyAddress3}}"
                v-pre>companyAddress3</el-dropdown-item>
            <el-dropdown-item
                command="{{companyCocInfo}}"
                v-pre>companyCocInfo</el-dropdown-item>
            <el-dropdown-item
                command="{{companyVatInfo}}"
                v-pre>companyVatInfo</el-dropdown-item>
            <el-dropdown-item
                command="{{launchYear}}"
                v-pre>launchYear</el-dropdown-item>
            <el-dropdown-item
                command="{{currentYear}}"
                v-pre>currentYear</el-dropdown-item>
            <el-dropdown-item
                command="{{modifiedDate}}"
                v-pre>modifiedDate</el-dropdown-item>
            <el-dropdown-item
                command="{{priceTable}}"
                v-pre>priceTable</el-dropdown-item>
            <el-dropdown-item
                command="{{premiumPriceTable}}"
                v-pre>premiumPriceTable</el-dropdown-item>
            <el-dropdown-item
                command="{{transactionCost}}"
                v-pre>transactionCost</el-dropdown-item>
            <el-dropdown-item
                command="{{partnerUrlAppend}}"
                v-pre>partnerUrlAppend</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {
  methods: {
    handleCommand(command) {
      this.$emit('copyToClipboard', command);
      this.$store.commit('getDropdownValue', command);
    },
  },
};
</script>
